import { motion } from 'framer-motion';
import { FileText, CheckCircle2, Loader2, XCircle } from 'lucide-react';

interface StatsRowProps {
  total: number;
  completed: number;
  analyzing: number;
  failed: number;
  pending: number;
}

export const StatsRow = ({ total, completed, analyzing, failed }: StatsRowProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-wrap gap-3 mb-4"
    >
      {/* 论文总数 */}
      <div className="flex items-center gap-2 px-3 py-2 bg-red-50 rounded-lg border border-red-100">
        <FileText size={16} className="text-[#94070a]" />
        <span className="text-sm font-semibold text-[#94070a]">{total}</span>
        <span className="text-xs text-[#94070a]/70">篇</span>
      </div>

      {/* 已完成 */}
      <div className="flex items-center gap-2 px-3 py-2 bg-green-50 rounded-lg border border-green-100">
        <CheckCircle2 size={16} className="text-green-600" />
        <span className="text-sm font-semibold text-green-700">{completed}</span>
        <span className="text-xs text-green-600/70">完成</span>
      </div>

      {/* 分析中 */}
      {analyzing > 0 && (
        <div className="flex items-center gap-2 px-3 py-2 bg-amber-50 rounded-lg border border-amber-100">
          <Loader2 size={16} className="text-amber-600 animate-spin" />
          <span className="text-sm font-semibold text-amber-700">{analyzing}</span>
          <span className="text-xs text-amber-600/70">分析中</span>
        </div>
      )}

      {/* 失败 */}
      {failed > 0 && (
        <div className="flex items-center gap-2 px-3 py-2 bg-red-50 rounded-lg border border-red-100">
          <XCircle size={16} className="text-red-600" />
          <span className="text-sm font-semibold text-red-700">{failed}</span>
          <span className="text-xs text-red-600/70">失败</span>
        </div>
      )}
    </motion.div>
  );
};

// 进度条组件 - 更紧凑
interface ProgressBarProps {
  progress: number;
  total: number;
  completed: number;
}

export const ProgressBar = ({ progress, total, completed }: ProgressBarProps) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="flex items-center gap-3 mb-4"
    >
      <div className="flex-1">
        <div className="flex justify-between text-xs mb-1">
          <span className="text-gray-500">分析进度</span>
          <span className="text-[#94070a] font-medium">{progress}%</span>
        </div>
        <div className="h-1.5 bg-gray-200 rounded-full overflow-hidden">
          <motion.div
            className="h-full bg-[#94070a] rounded-full"
            initial={{ width: 0 }}
            animate={{ width: `${progress}%` }}
            transition={{ type: 'spring', stiffness: 100, damping: 20 }}
          />
        </div>
      </div>
      <span className="text-xs text-gray-400 whitespace-nowrap">
        {completed}/{total} 篇
      </span>
    </motion.div>
  );
};
